module.exports = __webpack_public_path__ + "static/media/Style-Clubs-Serif-Italic.57b396dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Style-Clubs-Serif-Italic.svg
// module id = 3715
// module chunks = 71